import { FEATURE_FLAGS, useFeatureFlag } from '@/lib/feature-flags';
import { useWorkspacePreferences } from '@/lib/hooks/use-workspace-preferences';
import { isLovablePreview } from '@/lib/utils/environment';

/**
 * The single gate for every record-sharing entry point (share buttons, the
 * Sharing settings selectors): the RECORD_SHARING feature flag AND the
 * workspace's recordSharingEnabled preference. Preview mode is always on so
 * the UI is explorable in Lovable.
 */
export function useRecordSharingEnabled(): { enabled: boolean; loading: boolean } {
  const flagEnabled = useFeatureFlag(FEATURE_FLAGS.RECORD_SHARING);
  const { workspacePreferences, loading } = useWorkspacePreferences();

  if (isLovablePreview()) {
    return { enabled: true, loading: false };
  }
  return {
    enabled: flagEnabled && workspacePreferences?.recordSharingEnabled === true,
    loading,
  };
}
